export const escapeHtml = (html: $TSFixMe) => {
  const element = document.createElement('div');
  element.textContent = html;
  return element.innerHTML;
};
